import { ref } from 'vue'

const now = ref(Date.now())
let started = false

// One shared minute-tick so relative times keep updating while the app stays open.
export function useNow() {
  if (!started) {
    started = true
    setInterval(() => (now.value = Date.now()), 60000)
  }
  return now
}
